import client from '../request'

const getAll = `/user-groups`

const get = (id) => {
  return `/user-groups/${id}`
}

const create = (data) => {
  return client.post('/user-groups', data)
}

const update = (id, data) => {
  return client.put(`/user-groups/${id}`, data)
}

const getUser = (id) => {
  return `/user-groups/${id}/users`
}

const addUser = (id, data) => {
  return client.post(`/user-groups/${id}/users/add`, data)
}

const removeUser = (id, userId) => {
  return client.delete(`/user-groups/${id}/users/${userId}`)
}

const addPlan = (id, data) => {
  return client.post(`/user-groups/${id}/plans/add`, data)
}

const removePlan = (id, planId) => {
  return client.delete(`/user-groups/${id}/plans/${planId}`)
}

const toRow = (data) => {
  if (data?.data?.length > 0) {
    return data?.data.map((element) => {
      return {
        ...element,
        key: element.id
      }
    })
  }

  return []
}
const toPaginate = (data) => {
  return {
    total: data?.meta?.total ?? 0
  }
}

const remove = (id) => {
  return client.delete(`/user-groups/${id}`)
}

const UserGroupService = {
  getAll,
  get,
  create,
  getUser,
  addUser,
  removeUser,
  addPlan,
  removePlan,
  update,
  toRow,
  remove,
  toPaginate
}

export default UserGroupService
